import React from 'react';

import { forwardRef, Tooltip as ChakraTooltip } from '@chakra-ui/react';

import { TooltipProps } from './types/tooltip-props';

export const Tooltip = forwardRef<TooltipProps, 'div'>(function Tooltip(
  props,
  ref
) {
  return <ChakraTooltip ref={ref} {...props} hasArrow />;
});
